function BreadcrumbSkeleton() {
    return (
        <div className="h-5 w-32 animate-pulse rounded-md bg-zinc-200"></div>
    );
};

export default BreadcrumbSkeleton;